import SwiperCore, { Autoplay, Mousewheel, Navigation, Pagination } from 'swiper'
import type { SwiperProps } from 'swiper/react'
import { Swiper, SwiperSlide } from 'swiper/react'

SwiperCore.use([Autoplay, Pagination, Navigation, Mousewheel])

export const Slide = SwiperSlide

export default function Slider(props: SwiperProps) {
  return (
    <>
      <Swiper {...props}>{props.children}</Swiper>
    </>
  )
}
